package com.downdogapp.client

import com.downdogapp.client.controllers.SelectorOption

enum class StatType(override val id: Int) : Selectable {

  TOTAL_PRACTICES(0),
  MONTHLY_PRACTICES(1),
  TOTAL_TIME_PRACTICED(2),
  MONTHLY_TIME_PRACTICED(3),
  GOAL_STREAK(4),
  PRACTICE_STREAK(5);

  override val label
    get() = when (this) {
      TOTAL_PRACTICES -> Strings.TOTAL_PRACTICES_NOT_CAPITALIZED
      MONTHLY_PRACTICES -> Strings.MONTHLY_PRACTICES
      TOTAL_TIME_PRACTICED -> Strings.TOTAL_TIME_NOT_CAPITALIZED
      MONTHLY_TIME_PRACTICED -> Strings.MONTHLY_TIME_PRACTICED
      GOAL_STREAK -> Strings.GOAL_STREAK_NOT_CAPITALIZED
      PRACTICE_STREAK -> Strings.PRACTICE_STREAK_NOT_CAPITALIZED
    }

  companion object : SelectableCompanion<StatType>(entries)
}

enum class FirstDayOfWeek(override val id: Int) : Selectable {

  SUNDAY(0),
  MONDAY(1);

  override val label
    get() = when (this) {
      SUNDAY -> Strings.SUNDAY
      MONDAY -> Strings.MONDAY
    }

  companion object : SelectableCompanion<FirstDayOfWeek>(entries)
}

interface Selectable : IdEnum<Int> {

  val label: String
}

open class SelectableCompanion<T : Selectable>(private val values: List<T>) : IdEnumCompanion<Int, T>(values) {

  val ALL_SELECTOR_OPTIONS
    get() = values.map {
      SelectorOption(
        id = it.id,
        label = it.label
      )
    }
}

interface IdEnum<T> {

  val id: T
}

open class IdEnumCompanion<U : Any, T : IdEnum<U>>(values: List<T>) {

  private val ID_MAP = values.associateBy { it.id }
  fun fromId(id: U) = ID_MAP[id] ?: throw MissingIdException(id)
}

class MissingIdException(id: Any) : IllegalArgumentException("No id $id")
